"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _decorators = require("../../decorators");
var _domUtils = require("../../utils/dom-utils");
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _styles = require("./styles");
var _class, _InfiniteScrollComponent; //lodash
//helpers
//components
//styles
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InfiniteScrollComponent = (0, _decorators.styleable)(_class = (_InfiniteScrollComponent = /*#__PURE__*/function (_Component) {
  function InfiniteScrollComponent() {
    var _this;
    _classCallCheck(this, InfiniteScrollComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InfiniteScrollComponent, [].concat(args));
    _defineProperty(_this, "hostElement", null);
    _defineProperty(_this, "scrollParentElement", null);
    _defineProperty(_this, "asyncCheck", function () {
      return setTimeout(_this.check, 0);
    });
    _defineProperty(_this, "check", function () {
      var _this$props = _this.props,
        isLoading = _this$props.isLoading,
        threshold = _this$props.threshold;
      if (isLoading) {
        return;
      }
      if ((0, _domUtils.getScrollBottom)(_this.scrollParentElement) <= threshold) {
        (0, _invoke["default"])(_this.props, 'onBottom');
      }
    });
    _defineProperty(_this, "setHostRef", function (ref) {
      _this.hostElement = ref;
    });
    return _this;
  }
  _inherits(InfiniteScrollComponent, _Component);
  return _createClass(InfiniteScrollComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollParentElement = (0, _domUtils.findScrollParent)(this.hostElement) || window;
      this.scrollParentElement.addEventListener('scroll', this.check);
      this.asyncCheck();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isLoading = this.props.isLoading;
      if (prevProps.isLoading !== isLoading) {
        this.asyncCheck();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollParentElement.removeEventListener('scroll', this.check);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isLoading = _this$props2.isLoading,
        spinnerSize = _this$props2.spinnerSize;
      return /*#__PURE__*/_react["default"].createElement(_styles.InfiniteScroll, {
        ref: this.setHostRef,
        style: {
          height: spinnerSize
        }
      }, spinnerSize && isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        centerAbs: true,
        centerX: true,
        centerY: true,
        size: spinnerSize
      }));
    }
  }]);
}(_react.Component), _defineProperty(_InfiniteScrollComponent, "defaultProps", {
  spinnerSize: '2rem',
  threshold: 0
}), _defineProperty(_InfiniteScrollComponent, "propTypes", {
  /**
   * 1. Shows or hides the spinner
   * 2. When updates to false, the component re-checks itself to whether
   *    trigger onBottom callback once again.
   */
  isLoading: _propTypes["default"].bool,
  onBottom: _propTypes["default"].func,
  spinnerSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool]),
  threshold: _propTypes["default"].number
}), _InfiniteScrollComponent)) || _class;
var _default = exports["default"] = InfiniteScrollComponent;
//# sourceMappingURL=index.js.map